import { CommonModule } from "@angular/common";
import { Router, RouterModule } from "@angular/router";
import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { ListTableComponent } from "../../../shared/components/list-table/list-table.component";
import { PopupDialogComponent } from "../../../shared/components/popup-dialog/popup-dialog.component";
import { STATIC_JSON_DATA_PATH } from "../../../shared/constants/static-data.constants";
import { MEMBER_VIEW_PAGE_IDS } from "../../../shared/constants/page.constants";
import { UserService } from "../../../services/user.service";
import { StorageService } from "../../../services/storage.service";
import { NgZorroModule } from "../../../shared/modules/ng-zorro/ng-zorro.module";
import { AuthorizeDirective } from "../../../shared/authorization/authorize.directive.";
import { ListService } from "../../../shared/services/list.service";
import { BaseComponent } from "../../../shared/utils/base.component";
import { LoggerService } from "../../../shared/services/logger.service";
import { AuthorizationUtility } from "../../../shared/authorization/auth.utility";
import { AuthorizationService } from "../../../shared/authorization/authorization.service";
import { SectionsService } from "../../../services/sections.service";
import { HorizontalMenuItem, MenuItem } from "../../../interfaces/menu.interface";
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { ConfigListComponent } from "../config-list/config-list.component";
import { LookupConfigListComponent } from "../lookup-config-list/lookup-config-list.component";


@Component({
  selector: 'ppl-config-view',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NgZorroModule,
    NzTabsModule,
    AuthorizeDirective,
    PopupDialogComponent,
    ListTableComponent,
    ConfigListComponent,
    LookupConfigListComponent
],
  providers: [ListService],
  templateUrl: './config-view.component.html',
  styleUrl: './config-view.component.css',
})
export class ConfigViewComponent extends BaseComponent {

  sections = ['Application Config', 'Lookup Config'];
  selectedSection = 'Application Config';
  showAppConfig = true;

  constructor(

  ) {
    super();
  }

  onSectionSelection(item: string) {
    this.selectedSection = item;
    if (item === 'Lookup Config') {
      this.showAppConfig = false;
    } else {
      this.showAppConfig = true;
    }
  }


}
